module.exports = __webpack_public_path__ + "img/banner4.9358d34b.png";